// extracted by mini-css-extract-plugin
export default {"container":"ErrorScreen_container__PCZcp","message":"ErrorScreen_message__ELuQV"};